(function () {
  'use strict';

  angular.module('sempraWebapp').factory('CampaignTemplateItemViewModel', CampaignTemplateItemViewModelFactory);

  /** @ngInject */
  function CampaignTemplateItemViewModelFactory(CampaignTemplateEnum) {
    function CampaignTemplateItemViewModel(templateJson) {
      this.id = templateJson.id;
      this.name = templateJson.name;
      this.rules = [];

      templateJson.numberOfVisits.forEach(function (rule) {
        rule.type = CampaignTemplateEnum.NUM_OF_VISITS;
        this.push(rule);
      }, this.rules);

      templateJson.amountOfMoney.forEach(function (rule) {
        rule.type = CampaignTemplateEnum.MONEY_SPENT;
        this.push(rule);
      }, this.rules);

      templateJson.dailyTemporal.forEach(function (rule) {
        rule.type = CampaignTemplateEnum.DAILY_TEMPORAL;
        this.push(rule);
      }, this.rules);

      this.rulesCount = this.rules.length;

      init.call(this);
    }

    CampaignTemplateItemViewModel.prototype.destroy = function () {
    };

    return CampaignTemplateItemViewModel;

    function init() {
      refresh.call(this);
    }

    function refresh() {
    }
  }
})();
